import { InterInstance } from './config';

export const getBasePrice = async (token: string, edge: string, desc: string, model: string, gender: string) => {
  try {
    const { data } = await InterInstance.get(`/catalogs/price-from/`, {
      headers: { Authorization: `Bearer ${token}` },
      params: {edge, desc, model, gender }
    });
    return data.data[0];
  } catch (e) {
    return;
  }
};
